export default {
  zh_tw: {
    'aa':'aaa'
  }
}